class ReviewsCarousel {
  constructor(reviewsSlider, prevArrow, nextArrow) {
    this.reviewsSlider = reviewsSlider;
    this.prevArrow = prevArrow;
    this.nextArrow = nextArrow;

    this.flkty = new Flickity(reviewsSlider, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false
    });

    this.initialize();
  }
  
  initialize() {
    if (this.flkty.selectedIndex === 0) {
      this.prevArrow.style.display = 'none';
    }

    this.reviewsSlider.style.height = 'fit-content';

    this.prevArrow.addEventListener('click', () => {
      this.flkty.previous();

      if (this.flkty.selectedIndex === 0) {
        this.prevArrow.style.display = 'none';
      }

      if (this.flkty.selectedIndex !== this.flkty.cells.length - 1) {
        this.nextArrow.style.display = 'block';
      }
    });

    this.nextArrow.addEventListener('click', () => {
      this.flkty.next();

      if (this.flkty.selectedIndex === this.flkty.cells.length - 1) {
        this.nextArrow.style.display = 'none';
      }

      if (this.flkty.selectedIndex !== 0) {
        this.prevArrow.style.display = 'block';
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  let reviewsSlider = document.querySelector('.dtc-reviews-carousel');
  let prevArrow = document.querySelector('.dtc-reviews-carousel__prevArrow');
  let nextArrow = document.querySelector('.dtc-reviews-carousel__nextArrow');

  new ReviewsCarousel(reviewsSlider, prevArrow, nextArrow);
});


